import { NextTaskCard } from 'components/NextTaskCard'
import { carouselDashboard } from 'components/Carousel/config'
import { v4 as UuidV4 } from 'uuid'
import { Flex, Space, Skeleton, DashboardHeader, Carousel } from 'components'
import { arcHeroContentOffset } from 'components/ArcPageShell/constants'
import { useFeatureToggle, useMediaQuery, useMantineTheme } from 'hooks'

export const skeletonSlide = (
  <Skeleton visible={true}>
    <NextTaskCard
      projectName='loading'
      lessonName='loading'
      date='loading'
      time='loading'
      canFillEditReport={false}
      activities={[]}
      status='not_started'
      handleJournalClick={() => {}}
    />
  </Skeleton>
)

export const skeletonCarousel = (
  <Carousel {...carouselDashboard} withIndicators={false} withControls={false}>
    {[...Array(3)].map(() => (
      <Carousel.Slide key={UuidV4()}>{skeletonSlide}</Carousel.Slide>
    ))}
  </Carousel>
)

export const StudentDashBoardOnLoad = () => {
  const theme = useMantineTheme()
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`)
  const isArcEnabled = useFeatureToggle('arc-mosaico-project') as boolean

  return (
    <>
      <DashboardHeader name='loading' isloading={true} />
      <Flex>
        {/* Arc: hero clearance compensates the reduced container top padding (AR-578) */}
        <Skeleton visible h={30} w={200} mt={isArcEnabled ? arcHeroContentOffset(80, isMobile) : 80} />
      </Flex>
      <Space h='md' />
      {skeletonCarousel}
      <Flex>
        <Skeleton visible h={30} w={200} mt={32} />
      </Flex>
      <Space h='md' />
      {skeletonCarousel}
    </>
  )
}
